(() => {
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((list) => {
        const entry = list.getEntries().at(-1);
        if (!entry) return;
        document.documentElement.dataset.rgLcp = JSON.stringify({
          startTime: entry.startTime,
          renderTime: entry.renderTime,
          loadTime: entry.loadTime,
          size: entry.size,
          url: entry.url || '',
          alt: entry.element?.getAttribute?.('alt') || ''
        });
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_) {}
  }

  if (window.AvonticRhinoGuardGallery) return;

  const identityAttributes = ['data-media-id', 'data-media-position', 'data-media-type', 'data-rg-source-media-id'];

  const swapAttribute = (first, second, name) => {
    const firstValue = first.getAttribute(name);
    const secondValue = second.getAttribute(name);
    if (secondValue === null) first.removeAttribute(name); else first.setAttribute(name, secondValue);
    if (firstValue === null) second.removeAttribute(name); else second.setAttribute(name, firstValue);
  };

  const swapPayload = (first, second) => {
    identityAttributes.forEach((name) => swapAttribute(first, second, name));
    const firstNodes = Array.from(first.childNodes);
    const secondNodes = Array.from(second.childNodes);
    first.replaceChildren(...secondNodes);
    second.replaceChildren(...firstNodes);
  };

  const hydrateMedia = (root) => {
    root?.querySelectorAll?.('img[data-rg-src]').forEach((image) => {
      if (image.dataset.rgSrcset) image.srcset = image.dataset.rgSrcset;
      image.src = image.dataset.rgSrc;
      image.removeAttribute('data-rg-srcset');
      image.removeAttribute('data-rg-src');
    });
  };

  const selectColor = (gallery, mediaId) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    const firstCell = carousel?.children[0];
    const cells = Array.from(carousel?.children || []);
    const targetCell = cells.find((cell) => cell.dataset.mediaId === mediaId) || cells.find((cell) => cell.dataset.rgSourceMediaId === mediaId);
    if (!firstCell || !targetCell) return;

    hydrateMedia(targetCell);

    if (targetCell !== firstCell) {
      swapPayload(firstCell, targetCell);

      const navigation = gallery.querySelector('product-gallery-navigation');
      const firstButton = navigation?.children[0];
      const buttons = Array.from(navigation?.children || []);
      const targetButton = buttons.find((button) => button.dataset.mediaId === mediaId) || buttons.find((button) => button.dataset.rgSourceMediaId === mediaId);
      if (firstButton && targetButton && targetButton !== firstButton) swapPayload(firstButton, targetButton);
    }

    gallery.querySelectorAll('product-gallery-navigation > .product-gallery__thumbnail')
      .forEach((button, index) => button.setAttribute('aria-current', index === 0 ? 'true' : 'false'));
    carousel.select(0, { instant: true });

  };

  const connect = (gallery) => {
    if (gallery.dataset.rgSwapConnected === 'true') return;
    const form = document.getElementById(gallery.getAttribute('form'));
    if (!form) return;

    const hydrateNavigationTarget = (event) => {
      const button = event.target.closest?.('.product-gallery__thumbnail');
      if (!button || !gallery.contains(button)) return;
      const mediaId = button.dataset.mediaId;
      const cell = Array.from(gallery.querySelector('.product-gallery__carousel')?.children || [])
        .find((item) => item.dataset.mediaId === mediaId);
      hydrateMedia(cell);
    };

    gallery.addEventListener('pointerdown', hydrateNavigationTarget, true);
    gallery.addEventListener('focusin', hydrateNavigationTarget, true);

    form.addEventListener('variant:change', (event) => {
      const mediaId = event.detail?.variant?.featured_media?.id;
      if (event.target !== form || !mediaId) return;
      selectColor(gallery, String(mediaId).split('/').pop());
    });

    gallery.dataset.rgSwapConnected = 'true';
  };

  const connectWithin = (root) => {
    if (root?.matches?.('product-gallery[data-rg-gallery="true"]')) connect(root);
    root?.querySelectorAll?.('product-gallery[data-rg-gallery="true"]').forEach(connect);
  };

  window.AvonticRhinoGuardGallery = Object.freeze({ connect, connectWithin, selectColor });
  customElements.whenDefined('product-gallery').then(() => connectWithin(document));
  document.addEventListener('shopify:section:load', (event) => connectWithin(event.target));

  const hydrateDeferredMedia = () => {
    window.setTimeout(() => hydrateMedia(document), 5000);
  };

  if (document.readyState === 'complete') hydrateDeferredMedia();
  else window.addEventListener('load', hydrateDeferredMedia, { once: true });
})();
